import styled from 'styled-components'

import RightPanelEmptyState from '../components/RightPanelEmptyState'
import RightPanelLoadingState from '../components/RightPanelLoadingState'
import { useTripListRenderContent } from '../components/ListView/useTripListRenderContent'
import TripListMobileView from '../components/ListView/TripListMobileView'
import ListContainer from '../containers/ListContainer'
import { useItineraryContext } from '../contexts/ItineraryContext'
import { EmptyStateWrapper } from '../styles/layoutStyles'
import { useTripChatMobileAppShell } from './TripChatMobileAppShell'

const ListRoot = styled.div`
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
`

function TripChatMobileListView() {
  const { activeTab } = useTripChatMobileAppShell()
  const { itineraryData, isItineraryLoading } = useItineraryContext()
  const isListActive = activeTab === 'list'
  const hasListContent = useTripListRenderContent(itineraryData)

  if (!hasListContent) {
    return (
      <EmptyStateWrapper padding={24}>
        {isItineraryLoading ? <RightPanelLoadingState /> : <RightPanelEmptyState variant="list" />}
      </EmptyStateWrapper>
    )
  }

  return (
    <ListRoot data-testid="trip-chat-mobile-list-view">
      <ListContainer
        visible={isListActive}
        ViewComponent={TripListMobileView}
      />
    </ListRoot>
  )
}

export default TripChatMobileListView
